import '../../Orders/Dialogs/View/ViewOrderDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ToastContext from '../../../../context/ToastContext';
import useAxiosHook from '../../../../hooks/useAxiosHook';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { errorToast } from '../../../../utils/helpers/primereact';
import DialogSpinner from '../../../Dialogs/DialogSpinner/DialogSpinner';
import ViewOrderContent from '../../Orders/Dialogs/View/ViewOrderContent';

function ViewOrderDialog({ isShown, dataId, onHide, onHistory }) {
  const { t } = useTranslation();
  const toastRef = useContext(ToastContext)?.toastRef;

  const { data, isLoading, error } = useAxiosHook(`/orders/${dataId}`, {
    skipWhen: !dataId || !isShown,
  });

  const dialogFooter = (
    <>
      <Button
        label={t('History')}
        className="p-button-text"
        onClick={() => onHistory()}
      />
      <Button label={t('Close')} onClick={() => onHide()} />
    </>
  );

  const isOnMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (error) {
      errorToast(toastRef, t('Order preview failed'), String(error));
    }
    return;
  }, [error, t, toastRef]);

  return (
    <Dialog
      visible={isShown}
      onHide={onHide}
      header={t('Order {{order}}', {
        order: isLoading && !error ? '' : data?.seriski_broj,
      })}
      footer={dialogFooter}
      dismissableMask
      blockScroll
      maximizable
      maximized={isOnMobile}
      className="view-order-dialog"
    >
      {isLoading ? (
        <DialogSpinner />
      ) : data ? (
        <ViewOrderContent data={data} />
      ) : (
        <div>{t('Something went wrong')}</div>
      )}
    </Dialog>
  );
}

export default ViewOrderDialog;
